import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconArrowDown from '@assets/images/icons/arr_down2.svg'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  summary: {
    padding: '0 !important',
  },
  accordion: {
    borderTop: theme.border,
    borderBottom: theme.border,
    margin: '30px 0 0 0',
    boxShadow: 'none',
    border: 'none',
    '&.MuiAccordion-root.Mui-expanded': {
      margin: '0',
    },
    '&.MuiAccordion-root:before': {
      display: 'none',
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  title: ({ titleFontSize }) => ({
    height: '19px',
    margin: '10px 0 10px 1px',
    fontSize: titleFontSize || '16px',
    fontWeight: '500',
    letterSpacing: '0.16px',
    color: '#424a5f',
  }),
  icon: {
    fill: theme.DocumentControlButton.iconColor,
  },
  content: {
    width: '100%',
    overflowX: 'visible',
    flexDirection: 'column',
    padding: '0',
    '& p': {
      margin: '0 0 20px 0',
    },
    '&.withPadding': {
      paddingBottom: 10,
    },
    color: theme.black,
  },
}))

const DOAccordion = (props) => {
  const { title, content, className, expanded: initialState, titleAdornment } = props

  const [expanded, setExpanded] = useState(!!initialState)

  const classes = useStyles(props)

  const isString = typeof content === 'string'

  const details = isString
    ? content.split('\n').map((item, i) => {
      return item.trim()
        ? (
          <p key={'p-' + i}>
            {item.trim()}
          </p>
        )
        : null
    })
    : content

  return (
    <Accordion className={clsx(classes.accordion, className)} square={true} key={'pbbAccordion'} expanded={expanded} onChange={() => { setExpanded(!expanded) }}>
      <AccordionSummary className={classes.summary} expandIcon={<SVGIcon svg={IconArrowDown} height='16px' width='16px' customClass={classes.icon} />}>
        <span className={classes.titleContainer}>
          <Typography className={classes.title}>{title}</Typography>
          {titleAdornment}
        </span>
      </AccordionSummary>
      <AccordionDetails className={clsx(classes.content, { withPadding: !isString })}>
        {details}
      </AccordionDetails>
    </Accordion>
  )
}

DOAccordion.propTypes = {
  fontSize: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.node,
  expanded: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  titleAdornment: PropTypes.node,
}

export default DOAccordion
